import axios from "axios";
import { decryptData, encryptData } from "../../utils/api/encryption";
import { API_KEY, ENDPOINT } from "../../constant/environment";
const POC_API_URL =
  // "https://ruling-firstly-swine.ngrok-free.app/poc/chat";
  `${ENDPOINT}/app/v1/poc/chat`;
export interface iChatPocAPIPayload {
  messages: [
    {
      role: "assistant" | "user";
      content: string;
    },
  ];
}

export const CHAT_POC_RESPONSE_TYPE = {
  flight: "flight",
  hotel: "hotel",
  ai_assistant: "ai_assistant",
};

export async function chatPocApi(
  accessJWT: string,
  payload: iChatPocAPIPayload,
  signal?: AbortSignal,
  reqIdOverride?: string,
) {
  let config = {
    headers: {
      "Content-Type": "text/plain",
      "x-access-token": accessJWT,
      "x-api-key": API_KEY,
    },
    signal,
    // timeout: 1000
  };
  const reqId = reqIdOverride ?? Math.random().toString(36).slice(2, 8);
  const t0 = performance.now();
  const lastUserMsg = payload?.messages?.[payload.messages.length - 1];
  // eslint-disable-next-line no-console
  console.groupCollapsed(`[v2-FE-request ${reqId}] POST ${POC_API_URL}`);
  // eslint-disable-next-line no-console
  console.log("last user message:", lastUserMsg?.content);
  // eslint-disable-next-line no-console
  console.log("history depth:", payload?.messages?.length);
  // eslint-disable-next-line no-console
  console.log("full payload:", payload);
  // eslint-disable-next-line no-console
  console.groupEnd();
  try {
    const response = await axios.post(
      POC_API_URL,
      encryptData(payload),
      config,
    );
    const dt = Math.round(performance.now() - t0);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      const parsed = decryptedData ? JSON.parse(decryptedData) : null;
      const msgs = Array.isArray(parsed) ? parsed : parsed?.messages || parsed?.data;
      // eslint-disable-next-line no-console
      console.groupCollapsed(`[v2-FE-response ${reqId}] ${response.status} (${dt}ms)`);
      // eslint-disable-next-line no-console
      console.log("status:", response.status, "messages count:", Array.isArray(msgs) ? msgs.length : "n/a");
      if (Array.isArray(msgs)) {
        msgs.forEach((m: any, i: number) => {
          // eslint-disable-next-line no-console
          console.log(
            `  msg[${i}] type=${m?.type ?? "?"} source=${m?.source ?? "-"}` +
            (m?.name ? ` name=${m.name}` : "") +
            (typeof m?.text === "string" ? ` textLen=${m.text.length}` : ""),
            m,
          );
        });
      }
      // eslint-disable-next-line no-console
      console.log("full parsed response:", parsed);
      // eslint-disable-next-line no-console
      console.groupEnd();
      return parsed;
    }
    // eslint-disable-next-line no-console
    console.warn(`[v2-FE-response ${reqId}] empty response.data (${dt}ms)`);
    return null;
  } catch (error: any) {
    const dt = Math.round(performance.now() - t0);
    // eslint-disable-next-line no-console
    console.error(`[v2-FE-response ${reqId}] error (${dt}ms)`, {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
      code: error?.code,
    });
    return null;
  }
}

export async function chatPocVoiceApi(accessJWT: string) {
  let config = {
    headers: {
      "Content-Type": "text/plain",
      "x-access-token": accessJWT,
      "x-api-key": API_KEY,
    },
  };
  try {
    const response = await axios.get(`${ENDPOINT}/app/v1/poc/voice`, config);
    console.log("PAYLOAD");
    console.log("RESPONSE BEFORE DECRYPTION", response);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      console.log(["RESPONSE After DECRYPTION", JSON.parse(decryptedData)]);
      return decryptedData ? JSON.parse(decryptedData) : null;
    }
    return null;
  } catch (error: any) {
    return null;
  }
}
